<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">{{ this.moduleId ? '编辑' : '新建' }}模板</div>
    <div class="order-detail-basic">
      <el-form :model="fullReduction" label-width="100px" :rules="rules" ref="formRef">
        <el-form-item label="模板名称:" prop="mouldName">
          <el-input v-model="fullReduction.mouldName" placeholder="" style="width:420px !important;" type="text" maxlength="20" minlength="2" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="运费设置:" prop="activeTime"> 阶梯计价 </el-form-item>
        <el-form-item label="计价方式:">
          <el-radio-group v-model="fullReduction.feeType" @input="activityScopeChange">
            <el-radio :label="1">按重量</el-radio>
            <el-radio :label="2">按件数</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="运费计算:">
          <div>
            <div>
              <div style="color:#aaa;font-size:13px;">除指定地区外，其余地区运费采用："默认运费"</div>
            </div>
            <div class="ladderItem" style="display: flex;align-items: center;">默认运费 <div v-if="fullReduction.feeType == 1">
                <el-input-number v-model="moren.within" placeholder="请输入" controls-position="right" :min="0.1" :max="999.9" style="width:100px;margin: 0 10px;" :controls="false" precision="1">
                </el-input-number>kg以内，<el-input-number v-model="moren.withinPrice" placeholder="请输入" controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;"
                  :controls="false" precision="2"></el-input-number>元 ，每增加<el-input-number v-model="moren.everyIncrease" placeholder="请输入" controls-position="right" :min="0.1" :max="999.9"
                  style="width:100px;margin: 0 10px;" :controls="false" precision="1"></el-input-number>kg，增加运费<el-input-number v-model="moren.everyIncreasePrice" placeholder="请输入"
                  controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="2">
                </el-input-number>元
              </div>
              <div v-if="fullReduction.feeType == 2">
                <el-input-number v-model.number="moren.within" placeholder="请输入" controls-position="right" :min="1" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="0">
                </el-input-number>件以内，<el-input-number v-model="moren.withinPrice" placeholder="请输入" controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;" :controls="false"
                  precision="2"></el-input-number>元 ，每增加<el-input-number v-model.number="moren.everyIncrease" placeholder="请输入" controls-position="right" :min="1" :max="999"
                  style="width:100px;margin: 0 10px;" :controls="false" precision="0"></el-input-number>件，增加运费<el-input-number v-model="moren.everyIncreasePrice" placeholder="请输入"
                  controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="2">
                </el-input-number>元
              </div>
              <!-- <el-input-number v-model="moren.within" placeholder="请输入￥" controls-position="right" :min="fullReduction.feeType === 1 ? 0.1 : 1" :max="1000" style="width:100px;margin: 0 10px;"
                :controls="false" precision="1"></el-input-number>{{ fullReduction.feeType === 1 ? 'kg' : '件' }}以内，<el-input-number v-model="moren.withinPrice" placeholder="请输入￥"
                controls-position="right" :min="0.01" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="2"></el-input-number>元 ，每增加<el-input-number
                v-model="moren.everyIncrease" placeholder="请输入￥" controls-position="right" :min="fullReduction.feeType === 1 ? 0.1 : 1" :max="1000" style="width:100px;margin: 0 10px;"
                :controls="false" precision="1"></el-input-number> {{ fullReduction.feeType === 1 ? 'kg' : '件' }}，增加运费<el-input-number v-model="moren.everyIncreasePrice" placeholder="请输入￥"
                controls-position="right" :min="0.1" :max="1000" style="width:100px;margin: 0 10px;" :controls="false" precision="1">
              </el-input-number>元 -->
            </div>
            <div class="ladder">
              <div class="ladderItem" style="display: flex; align-items: center;  justify-content:space-between;">
                <div>指定地区运费<span>（可选）</span></div>
                <div style="display: flex;">
                  <div class="addRess" @click="deleteDialog = true, addAddressType = 'all'">删除</div>
                  <div class="addRess" @click="addAddress(1)">添加地区</div>
                </div>
              </div>
              <el-table :data="fullReduction.moduleFeeVOList" style="width: 100%;margin-top: 20px;" border @selection-change="handleSelectionChange">
                <!-- <el-table-column type="selection" width="55">
                </el-table-column> -->
                <el-table-column width="300px" prop="moduleFeeAreaVOStr" label="运送地区">
                </el-table-column>
                <el-table-column prop="themeName" label="计费规则">
                  <template v-slot="scope">
                    <div class="ladderItem">
                      <div v-if="fullReduction.feeType == 1">
                        <el-input-number v-model="scope.row.within" placeholder="请输入" controls-position="right" :min="0.1" :max="999.9" style="width:100px;margin: 0 10px;" :controls="false"
                          precision="1">
                        </el-input-number>kg以内，<el-input-number v-model="scope.row.withinPrice" placeholder="请输入" controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;"
                          :controls="false" precision="2"></el-input-number>元 ，每增加<el-input-number v-model="scope.row.everyIncrease" placeholder="请输入" controls-position="right" :min="0.1" :max="999.9"
                          style="width:100px;margin: 0 10px;" :controls="false" precision="1"></el-input-number>kg，增加运费<el-input-number v-model="scope.row.everyIncreasePrice" placeholder="请输入"
                          controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="2">
                        </el-input-number>元
                      </div>
                      <div v-if="fullReduction.feeType == 2">
                        <el-input-number v-model.number="scope.row.within" placeholder="请输入" controls-position="right" :min="1" :max="999" style="width:100px;margin: 0 10px;" :controls="false"
                          precision="0">
                        </el-input-number>件以内，<el-input-number v-model="scope.row.withinPrice" placeholder="请输入" controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;"
                          :controls="false" precision="2"></el-input-number>元 ，每增加<el-input-number v-model.number="scope.row.everyIncrease" placeholder="请输入" controls-position="right" :min="1"
                          :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="0"></el-input-number>件，增加运费<el-input-number v-model="scope.row.everyIncreasePrice"
                          placeholder="请输入" controls-position="right" :min="0" :max="999" style="width:100px;margin: 0 10px;" :controls="false" precision="2">
                        </el-input-number>元
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="10px">
                  <template v-slot="scope">
                    <span @click="deleteDialog = true, deleteSpuId = scope.row.id, addAddressType = 1, deleteIndex = scope.$index" class="color-blue">删除 <br></span>
                    <span @click="checkItem(scope, 1)" class="color-blue">修改地区<br></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="满X元包邮:">
          <el-input-number v-model="fullReduction.freeShippingPrice" placeholder="请输入" controls-position="right" :min="1" :max="99999" style="width:100px;margin: 0 10px;" :controls="false"
            precision="2"></el-input-number>元
        </el-form-item>
        <el-form-item label="指定条件包邮:">
          <div>指定区域设置满X元包邮，满足包邮条件有限按照包邮计算，不满足时按照阶梯价格计算</div>
          <!-- <div class="ladder"> -->
          <div class="ladderItem">
            <div class="addRess" @click="addAddress(2)" v-if="!fullReduction.freeShippingAreaStr">添加地区</div>
          </div>
          <el-table :data="freeShippingArea" style="width: 100%;margin-top: 20px;" border>
            <el-table-column prop="freeShippingAreaStr" label="包邮地区">
            </el-table-column>
            <el-table-column label="操作" width="200px">
              <template v-slot="scope">
                <span @click="deleteDialog = true, deleteSpuId = scope.row.id, addAddressType = 2" class="color-blue">删除 <br></span>
                <span @click="checkItem(scope, 2)" class="color-blue">修改地区<br></span>
              </template>
            </el-table-column>
          </el-table>
          <!-- </div> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="onSave()" v-preventReClick>保存</el-button>
      <el-button round @click="cancel()" v-preventReClick>取消</el-button>
    </div>
    <el-drawer :visible.sync="drawer" size="50%" title="运费地区选择">
      <div class="drawerContent">
        <!-- <el-cascader :props="options"></el-cascader> -->
        <el-cascader-panel id="cascaderPanel" v-if="isShowInfo" v-model="addressIds" :props="props" :options="options" @change="cascaderChange" style="height:calc(100vh - 320px)" ref="refCascader"
          destroy-on-close="true">
        </el-cascader-panel>
        <div class="selectAddress">
          <span v-for="(item, index) in selectAddress" :key="index">{{ item }}，</span>
        </div>
        <div class="form-btn" style="margin: 20px 0">
          <el-button round type="primary" @click="confirm()" v-preventReClick>确定</el-button>
          <el-button round @click="drawer = false, isShowInfo = false" v-preventReClick>取消</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认{{ addAddressType == 'all' ? '全部' : '' }}删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addressGetCountyByCityId, addressGetCityByProvinceCode, addressGetAllProvince } from '@/api/crm'
import { moduleAdd, moduleEdit, moduleDetail } from '@/api/pms'
import { addressData } from './address.js'
let selectAddressId = []
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      isShowInfo: false,
      deleteIndex: 0,
      addAddressType: '',
      addressIndex: undefined,
      deleteDialog: false,
      moren: {
        within: undefined,
        withinPrice: undefined,
        everyIncrease: undefined,
        everyIncreasePrice: undefined
      }, // 默认运费
      addressIds: [],
      selectAddressIds: [],
      selectAddress: [],
      options: addressData,
      // options: [{
      //   value: 'zhinan',
      //   label: '指南',
      //   children: [{
      //     value: 'shejiyuanze',
      //     label: '设计原则',
      //     children: [{
      //       value: 'yizhi',
      //       label: '一致'
      //     }, {
      //       value: 'fankui',
      //       label: '反馈'
      //     }, {
      //       value: 'xiaolv',
      //       label: '效率'
      //     }, {
      //       value: 'kekong',
      //       label: '可控'
      //     }]
      //   }, {
      //     value: 'daohang',
      //     label: '导航',
      //     children: [{
      //       value: 'cexiangdaohang',
      //       label: '侧向导航'
      //     }, {
      //       value: 'dingbudaohang',
      //       label: '顶部导航'
      //     }]
      //   }]
      // }, {
      //   value: 'zujian',
      //   label: '组件',
      //   children: [{
      //     value: 'basic',
      //     label: 'Basic',
      //     children: [{
      //       value: 'layout',
      //       label: 'Layout 布局'
      //     }, {
      //       value: 'color',
      //       label: 'Color 色彩'
      //     }, {
      //       value: 'typography',
      //       label: 'Typography 字体'
      //     }, {
      //       value: 'icon',
      //       label: 'Icon 图标'
      //     }, {
      //       value: 'button',
      //       label: 'Button 按钮'
      //     }]
      //   }, {
      //     value: 'form',
      //     label: 'Form',
      //     children: [{
      //       value: 'radio',
      //       label: 'Radio 单选框'
      //     }, {
      //       value: 'checkbox',
      //       label: 'Checkbox 多选框'
      //     }, {
      //       value: 'input',
      //       label: 'Input 输入框'
      //     }, {
      //       value: 'input-number',
      //       label: 'InputNumber 计数器'
      //     }, {
      //       value: 'select',
      //       label: 'Select 选择器'
      //     }, {
      //       value: 'cascader',
      //       label: 'Cascader 级联选择器'
      //     }, {
      //       value: 'switch',
      //       label: 'Switch 开关'
      //     }, {
      //       value: 'slider',
      //       label: 'Slider 滑块'
      //     }, {
      //       value: 'time-picker',
      //       label: 'TimePicker 时间选择器'
      //     }, {
      //       value: 'date-picker',
      //       label: 'DatePicker 日期选择器'
      //     }, {
      //       value: 'datetime-picker',
      //       label: 'DateTimePicker 日期时间选择器'
      //     }, {
      //       value: 'upload',
      //       label: 'Upload 上传'
      //     }, {
      //       value: 'rate',
      //       label: 'Rate 评分'
      //     }, {
      //       value: 'form',
      //       label: 'Form 表单'
      //     }]
      //   }, {
      //     value: 'data',
      //     label: 'Data',
      //     children: [{
      //       value: 'table',
      //       label: 'Table 表格'
      //     }, {
      //       value: 'tag',
      //       label: 'Tag 标签'
      //     }, {
      //       value: 'progress',
      //       label: 'Progress 进度条'
      //     }, {
      //       value: 'tree',
      //       label: 'Tree 树形控件'
      //     }, {
      //       value: 'pagination',
      //       label: 'Pagination 分页'
      //     }, {
      //       value: 'badge',
      //       label: 'Badge 标记'
      //     }]
      //   }, {
      //     value: 'notice',
      //     label: 'Notice',
      //     children: [{
      //       value: 'alert',
      //       label: 'Alert 警告'
      //     }, {
      //       value: 'loading',
      //       label: 'Loading 加载'
      //     }, {
      //       value: 'message',
      //       label: 'Message 消息提示'
      //     }, {
      //       value: 'message-box',
      //       label: 'MessageBox 弹框'
      //     }, {
      //       value: 'notification',
      //       label: 'Notification 通知'
      //     }]
      //   }, {
      //     value: 'navigation',
      //     label: 'Navigation',
      //     children: [{
      //       value: 'menu',
      //       label: 'NavMenu 导航菜单'
      //     }, {
      //       value: 'tabs',
      //       label: 'Tabs 标签页'
      //     }, {
      //       value: 'breadcrumb',
      //       label: 'Breadcrumb 面包屑'
      //     }, {
      //       value: 'dropdown',
      //       label: 'Dropdown 下拉菜单'
      //     }, {
      //       value: 'steps',
      //       label: 'Steps 步骤条'
      //     }]
      //   }, {
      //     value: 'others',
      //     label: 'Others',
      //     children: [{
      //       value: 'dialog',
      //       label: 'Dialog 对话框'
      //     }, {
      //       value: 'tooltip',
      //       label: 'Tooltip 文字提示'
      //     }, {
      //       value: 'popover',
      //       label: 'Popover 弹出框'
      //     }, {
      //       value: 'card',
      //       label: 'Card 卡片'
      //     }, {
      //       value: 'carousel',
      //       label: 'Carousel 走马灯'
      //     }, {
      //       value: 'collapse',
      //       label: 'Collapse 折叠面板'
      //     }]
      //   }]
      // }, {
      //   value: 'ziyuan',
      //   label: '资源',
      //   children: [{
      //     value: 'axure',
      //     label: 'Axure Components'
      //   }, {
      //     value: 'sketch',
      //     label: 'Sketch Templates'
      //   }, {
      //     value: 'jiaohu',
      //     label: '组件交互文档'
      //   }]
      // }],
      props: {
        multiple: true,
        checkStrictly: false,
        emitPath: false
        // lazy: true,
        // lazyLoad: async (node, resolve) => {
        //   const { level, value } = node
        //   console.log('level', node)
        //   console.log('selectAddressId', selectAddressId)
        //   let address = []
        //   if (level === 0) {
        //     await addressGetAllProvince().then(res => {
        //       if (res.data.success) {
        //         address = res.data.data.map(a => {
        //           return {
        //             ...a,
        //             type: 'province'
        //           }
        //         })
        //       }
        //     })
        //   } else if (level === 1 && value) {
        //     await addressGetCityByProvinceCode(value).then(res => {
        //       if (res.data.success) {
        //         address = res.data.data.map(a => {
        //           return {
        //             ...a,
        //             code: a.id,
        //             type: 'city'
        //           }
        //         })
        //       }
        //     })
        //   } else if (level === 2 && value) {
        //     await addressGetCountyByCityId(value).then(res => {
        //       if (res.data.success) {
        //         address = res.data.data.map(a => {
        //           return {
        //             ...a,
        //             code: a.id,
        //             type: 'county'
        //           }
        //         })
        //       }
        //     })
        //   }
        //   console.log('address', address)
        //   let nodes = address.map(item => {
        //     return {
        //       value: item.code,
        //       label: item.name,
        //       typeName: item.type,
        //       leaf: level >= 2
        //     }
        //   })
        //   // if (this.addAddressType == 'edit1' || this.addAddressType == 'edit2') {
        //   //   this.addressIds = selectAddressId
        //   //   console.log('this.addressIds', this.addressIds)
        //   // }
        //   resolve(nodes)
        // }
      },
      drawer: false,
      fullReduction: {
        mouldName: '',
        freeShippingAreaStr: '',
        freeShippingAreaList: [],
        freeShippingPrice: undefined,
        feeType: 1,
        moduleFeeVOList: []
      },
      freeShippingArea: [],
      moduleId: undefined,
      rules: {
        mouldName: [
          {
            required: true,
            message: '请填写模板名称',
            trigger: 'blur'
          }, {
            message: '请输入2-20个字符的模板名称',
            min: 2,
            max: 20
          }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.moduleId = this.$route.query.id
    if (this.moduleId) {
      this.getmoduleDetail()
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    activityScopeChange (val) {
      this.moren = {
        within: undefined,
        withinPrice: undefined,
        everyIncrease: undefined,
        everyIncreasePrice: undefined
      } // 默认运费
      this.fullReduction.moduleFeeVOList = []
      this.freeShippingArea = []
      this.fullReduction.freeShippingAreaStr = ''
      this.fullReduction.freeShippingAreaList = []
    },
    handleSelectionChange (val) {
      console.log('value', val)
    },
    // 添加地区
    addAddress (type) {
      this.addAddressType = type
      selectAddressId = []
      this.addressIds = []
      this.selectAddressIds = []
      this.selectAddress = []
      this.drawer = true
      this.isShowInfo = true
    },
    checkItem (item, type) {
      console.log('value', this.fullReduction.freeShippingAreaList)
      selectAddressId = []
      this.addressIds = []
      this.isShowInfo = false
      let val = item.row
      // 指定地区运费修改
      if (type == 1) {
        if (val.moduleFeeAreaVOList) {
          this.addressIds = val.moduleFeeAreaVOList.map(res => {
            let id = res.provinceid ? res.provinceid.toString() : res.cityid ? res.cityid : res.countyid ? res.countyid : 0
            return id
          })
          // this.addressIds = ['xiaolv', 'daohang', 'zhinan', 'zujian']
          console.log('selectAddressId', selectAddressId)
          this.selectAddress = val.moduleFeeAreaVOStr.split(',')
        }
        this.addAddressType = 'edit1'
        this.addressIndex = item.$index
        this.drawer = true
        this.$nextTick(() => {
          this.isShowInfo = true
        })
      }
      // 指定条件
      if (type == 2) {
        this.addressIds = this.fullReduction.freeShippingAreaList.map(res => {
          let id = res.provinceid ? res.provinceid.toString() : res.cityid ? res.cityid : res.countyid ? res.countyid : 0
          return id
        })
        this.selectAddress = this.fullReduction.freeShippingAreaStr.split(',')
        this.addAddressType = 'edit2'
        this.drawer = true
        this.$nextTick(() => {
          this.isShowInfo = true
        })
      }
    },
    getmoduleDetail () {
      moduleDetail(this.moduleId).then(res => {
        if (res.data.data) {
          console.log('this.moren', this.moren)
          let detail = res.data.data
          if (detail) {
            this.moren = detail.moduleFeeList.find(a => a.isDefault === 1)
            this.fullReduction = {
              mouldName: detail.mouldName,
              freeShippingAreaStr: detail.freeShippingArea,
              freeShippingAreaList: detail.freeShippingAreaList,
              freeShippingPrice: detail.freeShippingPrice,
              feeType: detail.feeType
            }
            this.fullReduction.moduleFeeVOList = detail.moduleFeeList.map(a => {
              return {
                ...a,
                moduleFeeAreaVOList: a.moduleFeeAreaList,
                moduleFeeAreaVOStr: a.area
              }
            }).filter(a => a.isDefault !== 1)
            if (detail.freeShippingArea) {
              this.freeShippingArea = [{
                freeShippingAreaStr: detail.freeShippingArea
              }]
            }
          }
        }
      })
    },
    confirm () {
      console.log('this.fullReduction.moduleFeeVOList', this.fullReduction.moduleFeeVOList)
      if (this.selectAddress.length < 1) {
        this.$message.error('请选择地区')
        return
      }
      if (this.addAddressType == 1 && this.selectAddressIds.length > 0) {
        this.fullReduction.moduleFeeVOList.push({
          everyIncrease: undefined,
          everyIncreasePrice: undefined,
          within: undefined,
          withinPrice: undefined,
          moduleFeeAreaVOList: this.selectAddressIds,
          moduleFeeAreaVOStr: this.selectAddress.toString()
        })
      }
      if (this.addAddressType == 'edit1' && this.selectAddressIds.length > 0) {
        console.log('xiugai 2131242')
        this.fullReduction.moduleFeeVOList[this.addressIndex].moduleFeeAreaVOList = this.selectAddressIds
        this.fullReduction.moduleFeeVOList[this.addressIndex].moduleFeeAreaVOStr = this.selectAddress.toString()
      }
      console.log('this.fullReduction.moduleFeeVOList+++', this.fullReduction.moduleFeeVOList)
      if ((this.addAddressType == 2 || this.addAddressType == 'edit2') && this.selectAddressIds.length > 0) {
        this.freeShippingArea = [{
          freeShippingAreaStr: this.selectAddress.toString()
        }]
        this.fullReduction.freeShippingAreaStr = this.selectAddress.toString()
        this.fullReduction.freeShippingAreaList = this.selectAddressIds
      }
      this.drawer = false
    },
    // cascaderChange (val) {
    //   console.log('val', val, '----', this.addressIds)
    //   selectAddressId = val
    //   // if (val.length > 0) {
    //   const arr = this.$refs.refCascader.getCheckedNodes()
    //   console.log('arr', arr)
    //   this.selectAddress = arr.map(res => {
    //     let str = res.pathLabels.toString()
    //     str = str.replace(/,/g, '/')
    //     return str
    //   })
    //   this.selectAddressIds = arr.map(res => {
    //     let { label, value } = res.data
    //     return {
    //       city: res.level == '2' ? label : '',
    //       cityid: res.level == '2' ? value : undefined,
    //       county: res.level == '3' ? label : '',
    //       countyid: res.level == '3' ? value : undefined,
    //       province: res.level == '1' ? label : '',
    //       provinceid: res.level == '1' ? value : undefined
    //     }
    //   })
    //   // }
    //   console.log('this.selectAddressIds', this.selectAddressIds)
    // },
    cascaderChange (val) {
      console.log('val', val, '----', this.addressIds)
      // if (val.length > 0) {
      const arr = this.$refs.refCascader.getCheckedNodes()
      console.log('arr', arr)
      // 省市区
      let provinceList = arr.filter(a => a.level == 1)
      let cityList = arr.filter(a => a.level == 2)
      let countyList = arr.filter(a => a.level == 3)

      // 所有省的Id
      let provinceListVal = provinceList.length > 0 ? provinceList.map(a => {
        return a.data.value
      }) : []
      // 所有市的Id
      let cityListVal = cityList.length > 0 ? cityList.map(a => {
        return a.data.value
      }) : []
      // console.log('provinceListVal', provinceListVal)
      // 判断市的父级有没有选中，过滤出没有选中省的市
      let cityListNew = provinceListVal.length > 0 ? cityList.filter(a => {
        if (provinceListVal.indexOf(a.data.parentId) == -1) {
          return a
        }
      }) : cityList
      // console.log('cityListNew', cityListNew)
      // 判断区的父级有没有选中，过滤出没有选中市的区
      let countyListNew = cityListVal.length > 0 ? countyList.filter(a => {
        if (cityListVal.indexOf(a.data.parentId) == -1) {
          return a
        }
      }) : countyList

      // console.log('countyListNew', countyListNew)
      // 省市区合成新的数组
      let newArr = provinceList.concat(cityListNew, countyListNew)
      this.selectAddress = newArr.map(res => {
        let str = res.pathLabels.toString()
        str = str.replace(/,/g, '/')
        return str
      })
      this.selectAddressIds = arr.map(res => {
        let { label, value } = res.data
        return {
          city: res.level == '2' ? label : '',
          cityid: res.level == '2' ? value : undefined,
          county: res.level == '3' ? label : '',
          countyid: res.level == '3' ? value : undefined,
          province: res.level == '1' ? label : '',
          provinceid: res.level == '1' ? value : undefined
        }
      })
      // }
      // console.log('this.selectAddressIds', this.selectAddressIds)
    },
    // 展开节点变化
    // expandChange (val) {
    //   console.log('expandChange', val)
    // },
    deleteAddress () {
      if (this.addAddressType == 'all') {
        this.fullReduction.moduleFeeVOList = []
      }
      if (this.addAddressType == 2) {
        this.freeShippingArea = []
        this.fullReduction.freeShippingAreaStr = ''
        this.fullReduction.freeShippingAreaList = []
      }
      if (this.addAddressType == 1 && this.fullReduction.moduleFeeVOList.length > 0) {
        console.log('this.deleteIndex ', this.deleteIndex)
        this.fullReduction.moduleFeeVOList.splice(this.deleteIndex, 1)
      }
      this.deleteDialog = false
    },
    onSave () {
      this.$refs.formRef.validate((valid) => {
        console.log('this.fullReduction', this.fullReduction)
        if (valid) {
          if (!this.moren.within || !this.moren.everyIncrease) {
            this.$message.error('请输入默认运费')
            return
          }
          if (this.fullReduction.moduleFeeVOList.length > 0) {
            let noWithin = this.fullReduction.moduleFeeVOList.find(a => !a.within)
            let noEveryIncrease = this.fullReduction.moduleFeeVOList.find(a => !a.everyIncrease)
            if (noWithin || noEveryIncrease) {
              this.$message.error('请输入指定地区运费')
              return
            }
          }
          if (this.fullReduction.freeShippingPrice && !this.fullReduction.freeShippingAreaStr) {
            this.$message.error('请选择指定条件包邮')
            return
          }
          if (this.fullReduction.freeShippingAreaStr && !this.fullReduction.freeShippingPrice) {
            this.$message.error('请输入包邮价格')
            return
          }
          if (this.moduleId) {
            let params = Object.assign(this.fullReduction, {
              defaultModuleFeeVO: this.moren,
              moduleType: 'PC',
              moduleId: this.moduleId
            })
            moduleEdit(params).then(res => {
              if (res.data.success) {
                this.$router.go(-1)
              }
            })
          } else {
            let params = Object.assign(this.fullReduction, {
              defaultModuleFeeVO: this.moren,
              moduleType: 'PC'
            })
            moduleAdd(params).then(res => {
              if (res.data.success) {
                this.$message.success('添加成功')
                this.$router.go(-1)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  // .spec-mm {
  //   span {
  //     margin-right: 10px;
  //   }

  //   .el-input {
  //     width: 110px;
  //   }

  //   @{deep} .el-input-group__append {
  //     padding: 0 15px;
  //   }
  // }

  // .link {
  //   width: 30px;
  //   height: 30px;
  //   border: 1px solid #dcdfe6;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   border-radius: 4px;
  //   box-sizing: border-box;

  //   i {
  //     font-size: 20px;
  //     color: #999;
  //   }
  // }

  // .active-link {
  //   background: #1473e6;
  //   border: 1px solid #1473e6;

  //   i {
  //     color: #fff;
  //   }
  // }
}

.activeType {
  margin-right: 20px;
  border: 1px solid #DCDFE6;
  padding: 15px;
  border-radius: 5px;
  width: 300px;

  p {
    font-size: 18px;
    padding-bottom: 5px;
    font-weight: 500;
    color: #000;
  }
}

.select {
  position: relative;
  border: 1px solid #409EFF !important;
  box-shadow: 0px 1px 3px 0px rgba(85, 110, 97, 0.35);

  ::before {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    border-top-right-radius: 5px;
    border: 15px solid #1473e6;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }

  ::after {
    content: '';
    width: 4px;
    height: 8px;
    position: absolute;
    right: 6px;
    top: 2px;
    border: 1px solid #fff;
    border-top-color: transparent;
    border-left-color: transparent;
    transform: rotate(35deg);
  }
}

.ladder {
  padding: 10px 10px;
  // background: rgb(243, 241, 241);
  background-color: #F5F7FA;

  .ladderItem {
    font-size: 12px;
  }
}

.addRess {
  font-size: 13px;
  border: 1px solid #409EFF;
  color: #409EFF;
  border-radius: 5px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  width: 70px;
  margin-right: 20px;
  cursor: pointer;
}

.drawerContent {
  padding: 0 20px;
  box-sizing: border-box;
}

.selectAddress {
  min-height: 140px;
  border: 1px solid #E4E7ED;
  margin-top: 8px;
  display: flex;

  flex-wrap: wrap;
  padding: 10px;
}

.tag {
  color: #666666;
  background-color: rgba(247, 247, 247, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(229, 230, 233, 1);
  padding: 5px;
}

/deep/ .el-cascader-menu__wrap {
  height: 100% !important;
}

/deep/ .el-cascader-menu {
  min-width: 33% !important;
}

/deep/ .el-input {
  width: 100% !important;
}
</style>
